/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobLogExitInformation_job$ref = any;
export type ExitInformationWrapperQueryVariables = {|
  id: string
|};
export type ExitInformationWrapperQueryResponse = {|
  +job: ?{|
    +$fragmentRefs: JobLogExitInformation_job$ref
  |}
|};
export type ExitInformationWrapperQuery = {|
  variables: ExitInformationWrapperQueryVariables,
  response: ExitInformationWrapperQueryResponse,
|};
*/


/*
query ExitInformationWrapperQuery(
  $id: ID!
) {
  job(uuid: $id) {
    __typename
    ...JobLogExitInformation_job
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment JobLogExitInformation_job on Job {
  __isJob: __typename
  ... on JobTypeCommand {
    uuid
    exitStatus
    softFailed
    events(first: 60) {
      edges {
        node {
          __typename
          actor {
            type
          }
          ... on JobEventFinished {
            exitStatus
            signal
            signalReason
          }
          ... on JobEventCanceled {
            exitStatus
            signal
            signalReason
          }
          ... on JobEventTimedOut {
            exitStatus
            signal
            signalReason
          }
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exitStatus",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signalReason",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitInformationWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobLogExitInformation_job"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitInformationWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJob"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "softFailed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 60
                  }
                ],
                "concreteType": "JobEventConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobEventEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JobEventActor",
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v5/*: any*/),
                            "type": "JobEventFinished",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v5/*: any*/),
                            "type": "JobEventCanceled",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v5/*: any*/),
                            "type": "JobEventTimedOut",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "events(first:60)"
              }
            ],
            "type": "JobTypeCommand",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "288e6e529efda10247a442dc65b2d83d",
    "id": null,
    "metadata": {},
    "name": "ExitInformationWrapperQuery",
    "operationKind": "query",
    "text": "query ExitInformationWrapperQuery(\n  $id: ID!\n) {\n  job(uuid: $id) {\n    __typename\n    ...JobLogExitInformation_job\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment JobLogExitInformation_job on Job {\n  __isJob: __typename\n  ... on JobTypeCommand {\n    uuid\n    exitStatus\n    softFailed\n    events(first: 60) {\n      edges {\n        node {\n          __typename\n          actor {\n            type\n          }\n          ... on JobEventFinished {\n            exitStatus\n            signal\n            signalReason\n          }\n          ... on JobEventCanceled {\n            exitStatus\n            signal\n            signalReason\n          }\n          ... on JobEventTimedOut {\n            exitStatus\n            signal\n            signalReason\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '59332628b3e0d4a2fe75640ba80ffbdd';

module.exports = node;
